// src/api/teamApi.js
import apiClient from './axios';

const teamApi = {
  getMyTeam: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/employees/my_team/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data;
  },
};

export default teamApi;